module.exports = __webpack_public_path__ + "static/20250407_HSE_Finance_S.à_r.l._Change_Mgmt_Alfonso-b6ec45ee5e898d37c4daaa0199c11df5.pdf";